import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=6b9c1ff8&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=6b9c1ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c1ff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9c1ff8')) {
      api.createRecord('6b9c1ff8', component.options)
    } else {
      api.reload('6b9c1ff8', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=6b9c1ff8&scoped=true&", function () {
      api.rerender('6b9c1ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2We82f2iGvkGZ/JS/comp/PopupBox.vue"
export default component.exports